(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cancellation-form"] && !Shopify.designMode) return;
  try {
    
  // The cancellation form (§ 312k BGB): «außerordentlich» opens the required reason, «zu einem Datum» the required date;
  // on submit the date and time in Zagreb go into the e-mail; after the redirect the page shows the buyer what was
  // sent and when, with «save or print» as the durable copy. Without storage the page still says it was sent.
  // The buyer's receipt shows the date and time without a place: Germany, Austria, Croatia and Slovenia share the
  // time zone, and German buyers see no Croatian place names; the shop's e-mail keeps «(Zagreb)».
  class CancellationForm extends HTMLElement {
    static stamp(date) {
      const parts = new Intl.DateTimeFormat('de-DE', {
        timeZone: 'Europe/Zagreb', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
      }).formatToParts(date).reduce((all, p) => ({ ...all, [p.type]: p.value }), {});
      return `${parts.day}.${parts.month}.${parts.year}, ${parts.hour}:${parts.minute}`;
    }
    connectedCallback() {
      const receipt = this.querySelector('[data-cancel-receipt]');
      if (receipt) { this.showReceipt(receipt); return; }
      const form = this.querySelector('form');
      if (!form) return;
      const toggle = (box, on) => {
        if (!box) return;
        box.hidden = !on;
        box.querySelectorAll('input, textarea').forEach((el) => { el.disabled = !on; el.required = on; });
      };
      const sync = () => {
        toggle(this.querySelector('[data-cancel-reason]'), !!form.querySelector('[data-kind="extra"]:checked'));
        toggle(this.querySelector('[data-cancel-date]'), !!form.querySelector('[data-when="date"]:checked'));
      };
      const day = this.querySelector('#CancelDate');
      if (day) { const now = new Date(); day.min = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 10); }
      form.addEventListener('change', sync);
      sync();
      form.addEventListener('submit', () => {
        const value = (sel) => (form.querySelector(sel) || {}).value || '';
        const time = CancellationForm.stamp(new Date());
        const field = form.querySelector('[data-cancel-time]');
        if (field) field.value = `${time} (Zagreb)`;
        const date = value('#CancelDate');
        const sent = {
          time,
          kind: value('[name="contact[Kind]"]:checked'),
          reason: form.querySelector('[data-kind="extra"]:checked') ? value('#CancelReason') : '',
          contract: value('#CancelContract'),
          end: form.querySelector('[data-when="date"]:checked') && date ? date.split('-').reverse().join('.') : value('[name="contact[End]"]:checked'),
          name: value('#CancelName'),
          email: value('#CancelEmail'),
        };
        try { sessionStorage.setItem('df-cancellation', JSON.stringify(sent)); } catch (e) { /* storage off: the e-mail still confirms */ }
      });
    }
    showReceipt(receipt) {
      let sent = null;
      try { sent = JSON.parse(sessionStorage.getItem('df-cancellation') || 'null'); } catch (e) { sent = null; }
      if (!sent || !sent.time) return;
      const fill = (key, text) => {
        const slot = receipt.querySelector(`[data-receipt="${key}"]`);
        if (slot) slot.textContent = text;
      };
      ['time', 'kind', 'reason', 'end', 'name', 'email'].forEach((k) => fill(k, sent[k] || ''));
      fill('contract', sent.contract || receipt.dataset.contractNone || '');
      if (!sent.reason) receipt.querySelectorAll('[data-receipt-row="reason"], [data-receipt="reason"]').forEach((el) => { el.hidden = true; });
      receipt.hidden = false;
      const print = receipt.querySelector('[data-cancel-print]');
      if (print) print.addEventListener('click', () => window.print());
      try { sessionStorage.removeItem('df-cancellation'); } catch (e) { /* nothing to clean */ }
    }
  }
  if (!customElements.get('cancellation-form')) customElements.define('cancellation-form', CancellationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // The products panel opens on click or tap (details), and with a mouse also on hover; the phone menu fits the
  // screen below the header.
  (() => {
    document.querySelectorAll('details[data-hover-open]').forEach((d) => {
      let timer = null;
      d.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(timer);
        timer = setTimeout(() => { d.open = true; }, 90);
      });
      d.addEventListener('pointerleave', (e) => {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(timer);
        timer = setTimeout(() => { d.open = false; }, 220);
      });
    });
    const nav = document.getElementById('MobileNav');
    const header = nav && nav.closest('header');
    if (!nav || !header) return;
    const fit = () => {
      if (nav.hidden) return;
      nav.style.maxHeight = Math.max(240, window.innerHeight - header.getBoundingClientRect().bottom) + 'px';
    };
    new MutationObserver(fit).observe(nav, { attributes: true, attributeFilter: ['hidden'] });
    window.addEventListener('resize', fit);
    window.addEventListener('scroll', fit, { passive: true });
  })();

  // Language and delivery country (locale-panel): the country by IP inside this shop version, a hint for the other one.
  (() => {
    const store = {
      get(k) { try { return localStorage.getItem(k); } catch { return null; } },
      set(k, v) { try { localStorage.setItem(k, v); } catch { /* private mode */ } },
      sget(k) { try { return sessionStorage.getItem(k); } catch { return null; } },
      sset(k, v) { try { sessionStorage.setItem(k, v); } catch { /* private mode */ } },
    };
    // openers: the phone sheet (a dialog) and the footer «change» link (opens the footer panel)
    document.querySelectorAll('[data-lsheet-open]').forEach((b) => b.addEventListener('click', () => {
      const d = document.getElementById(b.dataset.lsheetOpen);
      if (d && typeof d.showModal === 'function') d.showModal();
    }));
    document.querySelectorAll('dialog.lsheet').forEach((d) => {
      d.addEventListener('click', (e) => { if (e.target === d) d.close(); });
      d.querySelectorAll('[data-lsheet-close]').forEach((b) => b.addEventListener('click', () => d.close()));
    });
    document.querySelectorAll('[data-lpick-open]').forEach((b) => b.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const d = document.getElementById(b.dataset.lpickOpen);
      if (d) d.open = true;
    }));

    const panels = [...document.querySelectorAll('[data-locale-panel]')];
    if (!panels.length) return;
    const first = panels[0];
    const current = (first.dataset.country || '').toUpperCase();
    const language = first.dataset.language || '';
    const root = (first.dataset.root || '/').replace(/\/?$/, '/');
    const countries = (first.dataset.countries || '').split(',').filter(Boolean);
    const groups = (first.dataset.groups || '').split('|').map((g) => g.split(','));
    let texts = {};
    try { texts = JSON.parse(first.dataset.geoTexts || '{}'); } catch { texts = {}; }
    const nav = navigator || {};
    const bot = nav.webdriver || /bot|crawl|spider|slurp|lighthouse|headless|preview|adsbot|mediapartners|facebookexternalhit/i.test(nav.userAgent || '');

    const switchTo = (country, lang) => {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = `${root}localization`;
      form.hidden = true;
      const add = (name, value) => { const i = document.createElement('input'); i.name = name; i.value = value; form.appendChild(i); };
      add('_method', 'PUT');
      add('country_code', country);
      if (lang) add('language_code', lang);
      add('return_to', location.pathname + location.search);
      document.body.appendChild(form);
      form.submit();
    };

    const detect = async () => {
      // testing on an unpublished theme only: ?df_geo=AT stands in for the GeoIP country (ignored on the live theme)
      const theme = window.Shopify && window.Shopify.theme;
      const forced = (/[?&]df_geo=([A-Za-z]{2})/.exec(location.search) || [])[1] || store.sget('df:geo-test');
      if (forced && theme && theme.role !== 'main') { store.sset('df:geo-test', forced); return forced.toUpperCase(); }
      const cached = store.sget('df:geo');
      if (cached) return cached;
      try {
        const res = await fetch(`${root}browsing_context_suggestions.json?country[enabled]=true`, { headers: { Accept: 'application/json' } });
        if (!res.ok) return null;
        const data = await res.json();
        const s = data && data.suggestions && data.suggestions[0] && data.suggestions[0].parts;
        const code = ((data && data.detected_values && data.detected_values.country && data.detected_values.country.handle) || (s && s.country && s.country.handle) || '').toUpperCase();
        if (code) store.sset('df:geo', code);
        return code || null;
      } catch {
        return null;
      }
    };

    // the language of the visitor's country, offered in that language — never switched without a tap (Vasily's «hint»)
    const LANG_OF = { DE: 'de', AT: 'de', HR: 'hr', SI: 'sl' };
    const OFFER = { de: 'Auf Deutsch lesen', hr: 'Čitajte na hrvatskom', sl: 'Berite v slovenščini', en: 'Read in English' };
    const languages = (first.dataset.languages || '').split(',').filter(Boolean);
    const offerLanguage = (det) => {
      const want = LANG_OF[det];
      if (!want || want === language || !languages.includes(want) || store.get('df:locale-chosen') || bot) return;
      document.querySelectorAll('[data-lang-go]').forEach((b) => {
        b.textContent = `${OFFER[want]} ›`;
        b.lang = want;
        b.hidden = false;
        const wrap = b.closest('[data-lang-hint]');
        if (wrap) wrap.hidden = false;
        b.addEventListener('click', () => { store.set('df:locale-chosen', '1'); switchTo(current, want); });
      });
      document.querySelectorAll('[data-lang-hint-text]').forEach((el) => { el.textContent = OFFER[want]; el.lang = want; el.hidden = false; });
    };

    detect().then((det) => {
      if (!det || !countries.includes(det)) return;
      if (det === current) {
        document.querySelectorAll('[data-geo-auto]').forEach((el) => { el.hidden = false; });
        offerLanguage(det);
        return;
      }
      const sameVersion = groups.some((g) => g.includes(det) && g.includes(current));
      if (sameVersion) {
        // inside this shop version: the country is set by itself, once, unless the visitor chose by hand
        if (!bot && !store.get('df:locale-chosen') && !store.sget('df:geo-country')) {
          store.sset('df:geo-country', '1');
          switchTo(det, null);
          return;
        }
        offerLanguage(det);
        return;
      }
      // another shop version: a hint, and only a tap moves the visitor (with the language they read now)
      const text = texts[det];
      if (!text) return;
      document.querySelectorAll('[data-geo-hint]').forEach((el) => {
        const t = el.querySelector('[data-geo-hint-text]');
        if (t) t.textContent = text;
        el.hidden = false;
      });
      document.querySelectorAll('[data-geo-go]').forEach((b) => b.addEventListener('click', () => {
        store.set('df:locale-chosen', '1');
        switchTo(det, language);
      }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-wall"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const still = window.matchMedia('(prefers-reduced-motion: reduce)');
    const saveData = navigator.connection && navigator.connection.saveData;
    document.querySelectorAll('[data-hwall]').forEach((wall) => {
      const secs = parseFloat(wall.dataset.hwallSeconds) || 8;
      const tracks = [...wall.querySelectorAll('.hwall__track')];
      // The loop: every column shows its tiles twice and slides by one copy. The copy is for the eye only.
      if (!still.matches) {
        tracks.forEach((track) => {
          const set = track.querySelector('.hwall__set');
          if (!set || !set.children.length) return;
          const copy = set.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          copy.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
          copy.querySelectorAll('button').forEach((el) => el.setAttribute('tabindex', '-1'));
          track.appendChild(copy);
        });
        // Speed: a square photo moves by its own height (plus the gap) in «seconds per photo», in every column and at
        // every width; the columns differ a little (data-hwall-pace) so they never move in step. The set's height comes
        // from the tiles' aspect ratios, so it is right before the pictures load; tiles hidden on phones do not count.
        const pace = () => tracks.forEach((track) => {
          const set = track.querySelector('.hwall__set');
          const step = track.parentElement.clientWidth + 10;
          if (!set || step <= 10) return;
          const f = parseFloat(track.dataset.hwallPace) || 1;
          track.style.setProperty('--hwall-dur', ((set.offsetHeight / step) * secs * f).toFixed(1) + 's');
        });
        pace();
        let timer = 0;
        let lastWidth = window.innerWidth;
        window.addEventListener('resize', () => {
          clearTimeout(timer);
          timer = setTimeout(() => {
            if (window.innerWidth === lastWidth) return;   // a phone's address bar changes only the height
            lastWidth = window.innerWidth;
            pace();
          }, 200);
        });
        wall.classList.add('is-moving');
      }
      // The short silent loops play by themselves, muted, while they are on screen — on phones too; not with «reduce
      // motion», data saver, a hidden tab or the player open (then a tap plays them).
      const videos = [...wall.querySelectorAll('video[data-hwall-video]')];
      const paused = () => wall.classList.contains('is-paused');
      const inView = new Set();
      const playLoop = (video) => {
        if (!still.matches && !saveData && !paused() && !document.hidden) video.play().catch(() => {});
      };
      if (videos.length && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting) {
              inView.add(video);
              playLoop(video);
            } else {
              inView.delete(video);
              video.pause();
            }
          });
        }, { threshold: 0.2 });
        videos.forEach((video) => io.observe(video));
      }
      const resumeLoops = () => videos.forEach((video) => { if (inView.has(video)) playLoop(video); });
      // No pause button: the wall stops by itself while nobody can see it — a hidden tab, or scrolled off screen.
      const away = () => {
        if (document.hidden) videos.forEach((video) => video.pause());
        else resumeLoops();
      };
      document.addEventListener('visibilitychange', () => {
        wall.classList.toggle('is-away', document.hidden || wall.dataset.hwallOff === '1');
        away();
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          wall.dataset.hwallOff = entry.isIntersecting ? '0' : '1';
          wall.classList.toggle('is-away', document.hidden || !entry.isIntersecting);
        }).observe(wall);
      }
      // «Ansehen»: a tile with a full version opens it with sound; a clip with words in the picture opens big, muted and
      // looping. The wall stands still while the player is open. A plain loop plays or stops on tap.
      const player = wall.querySelector('[data-hwall-player]');
      const playerVideo = player && player.querySelector('video');
      wall.addEventListener('click', (e) => {
        const watch = e.target.closest('[data-hwall-watch]');
        if (watch && player && playerVideo) {
          e.preventDefault();
          const [w, h] = (watch.dataset.hwallRatio || '9/16').split('/').map(Number);
          player.style.setProperty('--hwall-r', String(w / h || 0.5625));
          const silent = !watch.dataset.hwallSound;
          playerVideo.muted = silent;
          playerVideo.loop = silent;
          playerVideo.src = watch.dataset.hwallWatch;
          wall.classList.add('is-paused');
          videos.forEach((video) => video.pause());
          player.showModal();
          playerVideo.play().catch(() => {});
          return;
        }
        const tile = e.target.closest('[data-hwall-tile]');
        const video = tile && tile.querySelector('video');
        if (video) {
          if (video.paused) video.play().catch(() => {});
          else video.pause();
        }
      });
      if (player && playerVideo) {
        // the player takes the proportions of the file itself (a full version may be 9:16 or 9:15)
        playerVideo.addEventListener('loadedmetadata', () => {
          if (playerVideo.videoWidth && playerVideo.videoHeight) {
            player.style.setProperty('--hwall-r', String(playerVideo.videoWidth / playerVideo.videoHeight));
          }
        });
        player.querySelector('[data-hwall-close]')?.addEventListener('click', () => player.close());
        player.addEventListener('click', (e) => {
          if (e.target === player) player.close();
        });
        player.addEventListener('close', () => {
          playerVideo.pause();
          playerVideo.removeAttribute('src');
          playerVideo.load();
          wall.classList.remove('is-paused');
          resumeLoops();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero-rasteg]').forEach((demo) => {
    const cuff = demo.querySelector('[data-rasteg-cuff]');
    const input = demo.querySelector('[data-rasteg-input]');
    const status = demo.querySelector('[data-rasteg-status]');
    if (!cuff || !input || !status) return;
    const draw = (value) => {
      cuff.style.width = `${Math.round(200 + value * 1.5)}px`;
      if (value < 8) {
        status.textContent = status.dataset.textRest;
      } else {
        const factor = (1 + value / 66).toFixed(1).replace('.', ',');
        status.textContent = status.dataset.textStretch.replace('[x]', factor);
      }
    };
    const release = () => {
      input.value = 34;
      draw(34);
      status.textContent = status.dataset.textRelease;
    };
    input.addEventListener('input', () => draw(parseInt(input.value, 10)));
    input.addEventListener('change', release);
    input.addEventListener('mouseup', release);
    input.addEventListener('touchend', release);
    draw(34);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo-strip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const still = window.matchMedia('(prefers-reduced-motion: reduce)');
    document.querySelectorAll('[data-pstrip]').forEach((rail) => {
      const grid = rail.querySelector('.pstrip__grid');
      const prev = rail.querySelector('[data-pstrip-prev]');
      const next = rail.querySelector('[data-pstrip-next]');
      if (!grid || !prev || !next) return;
      const update = () => {
        const img = grid.querySelector('img');
        if (img && img.offsetHeight) rail.style.setProperty('--pstrip-mid', img.offsetHeight / 2 + 'px');
        const over = grid.scrollWidth > grid.clientWidth + 2;
        prev.hidden = !over || grid.scrollLeft < 4;
        next.hidden = !over || grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 4;
      };
      // one step = one photo and the gap
      const step = () => {
        const tile = grid.firstElementChild;
        const gap = parseFloat(getComputedStyle(grid).columnGap) || 12;
        return tile ? tile.getBoundingClientRect().width + gap : grid.clientWidth * 0.8;
      };
      const go = (dir) => grid.scrollBy({ left: dir * step(), behavior: still.matches ? 'auto' : 'smooth' });
      prev.addEventListener('click', () => go(-1));
      next.addEventListener('click', () => go(1));
      grid.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      grid.querySelectorAll('img').forEach((img) => img.addEventListener('load', update, { once: true }));
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  // review-wall — «Show more»: reveals the next batch of hidden reviews (DS.ReviewWall step)
  class ReviewWall extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-wall-more]');
      if (!this.btn) return;
      this.step = parseInt(this.dataset.initial || '8', 10) || 8;
      this.btn.addEventListener('click', () => this.reveal());
    }
    reveal() {
      const hidden = [...this.querySelectorAll('.reviews__grid > .is-hidden')];
      hidden.slice(0, this.step + 2).forEach((el) => el.classList.remove('is-hidden'));
      const left = this.querySelectorAll('.reviews__grid > .review.is-hidden').length;
      const shown = this.querySelectorAll('.reviews__grid > .review:not(.is-hidden)').length;
      const s = this.querySelector('[data-wall-shown]'); if (s) s.textContent = String(shown);
      const l = this.querySelector('[data-wall-left]'); if (l) l.textContent = String(left);
      if (!left) this.btn.remove();
    }
  }
  if (!customElements.get('review-wall')) customElements.define('review-wall', ReviewWall);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["proof-summary"] && !Shopify.designMode) return;
  try {
    
  /* «Show more» of the reviews wall: opens the next batch (on a phone first the rest of the first one), keeps «9 of 63»
     and «(7)» true, hides itself after the last batch and moves the focus to the first card it opened.
     The open cards stand in columns laid out by the script: each card goes under the shortest column, in order, so a
     batch that opens fills the columns from where they end — no hole under a short column, and the cards already seen
     never move (the same cards in the same order land in the same places). Without the script: CSS columns per batch. */
  if (!customElements.get('proof-wall')) {
    class ProofWall extends HTMLElement {
      connectedCallback() {
        this.cards = [...this.querySelectorAll('.pwall__grid[data-batch] .rvoice')];
        if (!this.cards.length) return;
        this.total = Number(this.dataset.total) || 0;
        this.phone = window.matchMedia('(max-width: 640px)');
        this.wide = window.matchMedia('(min-width: 1080px)');
        const first = this.querySelector('.pwall__grid[data-batch]');
        this.cards.forEach((card) => {
          const inFirst = card.parentElement === first;
          card.dataset.open = inFirst && !(this.phone.matches && card.classList.contains('is-m-later')) ? '1' : '0';
          card.dataset.pwFirst = inFirst ? '1' : '0';
        });
        first.dataset.used = '1';
        this.mason = document.createElement('div');
        this.mason.className = 'pwall__mason';
        first.before(this.mason);
        this.classList.add('is-laid');
        this.more = this.querySelector('[data-more]');
        if (this.more) {
          this.more.hidden = false;
          this.more.addEventListener('click', () => this.open());
        }
        const relayout = () => this.layout();
        [this.phone, this.wide].forEach((mq) => mq.addEventListener && mq.addEventListener('change', relayout));
        this.layout();
      }
      layout() {
        const n = this.phone.matches ? 1 : this.wide.matches ? 3 : 2;
        this.mason.style.setProperty('--pwall-cols', n);
        const cols = [];
        this.mason.textContent = '';
        for (let i = 0; i < n; i += 1) {
          const col = document.createElement('div');
          col.className = 'pwall__mcol';
          this.mason.appendChild(col);
          cols.push(col);
        }
        const heights = cols.map(() => 0);
        this.cards.filter((card) => card.dataset.open === '1').forEach((card) => {
          card.classList.remove('is-m-later');
          const i = heights.indexOf(Math.min(...heights));
          cols[i].appendChild(card);
          heights[i] += card.getBoundingClientRect().height + 16;
        });
        this.update();
      }
      update() {
        const n = this.cards.filter((card) => card.dataset.open === '1').length;
        const shownEl = this.querySelector('[data-shown]');
        const leftEl = this.querySelector('[data-left]');
        if (shownEl) shownEl.textContent = n;
        if (leftEl) leftEl.textContent = Math.max(this.total - n, 0);
        if (this.more) this.more.hidden = n >= this.cards.length;
      }
      open() {
        // a phone first opens the rest of the first batch, then — like a computer — the next batch from the store
        let opened = this.cards.filter((card) => card.dataset.pwFirst === '1' && card.dataset.open !== '1');
        if (!opened.length) {
          const batch = this.querySelector('.pwall__grid[data-batch]:not([data-used])');
          if (!batch) return;
          batch.dataset.used = '1';
          opened = [...batch.querySelectorAll('.rvoice')];
          opened.forEach((card) => { card.dataset.pwFirst = '1'; });
        }
        opened.forEach((card) => { card.dataset.open = '1'; });
        this.layout();
        if (opened[0]) {
          opened[0].setAttribute('tabindex', '-1');
          opened[0].focus({ preventScroll: true });
        }
      }
    }
    customElements.define('proof-wall', ProofWall);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-cta"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sticky-cta]').forEach((bar) => {
    const onScroll = () => {
      const show = window.scrollY > 480;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('has-scta', show);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-thread"] && !Shopify.designMode) return;
  try {
    
  // phones: the one-line ribbon scrolls so the chapter the reader is in (IV on the product page) is in view
  (() => {
    const show = () => document.querySelectorAll('.sthread__list').forEach((list) => {
      const cur = list.querySelector('.sthread__item--current');
      if (!cur || list.scrollWidth <= list.clientWidth) return;
      if (cur.offsetLeft + cur.offsetWidth <= list.clientWidth - 24) return;
      list.scrollLeft = Math.max(0, cur.offsetLeft - 8);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', show, { once: true });
    else show();
  })();

  } catch(e) { console.error(e); }
})();
})();
